import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { contexts } from 'constants/contexts';
import { setContext } from 'modules/labs/common/actions';
import MasterListView from 'modules/labs/masterList/views/MasterListView';
import { fetchServicesCatalog } from 'modules/labs/masterList/actions';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MasterListPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const listQueryStrings = useMemo(
    () => ({
      page: 1,
      pageSize: 5,
      includeTotalCount: true,
    }),
    [],
  );
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setContext(contexts.masterList));
    dispatch(fetchServicesCatalog(listQueryStrings));
  }, [dispatch, listQueryStrings]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <MasterListView listQueryStrings={listQueryStrings} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MasterListPage.propTypes = {};

MasterListPage.defaultProps = {};

export default MasterListPage;
